import { StorageSet, UseCase } from '@mdd/api';

export class SetLastLogin implements UseCase<void, void> {
    private storageSet = new StorageSet<number>();

    execute(): void {
        this.storageSet.execute({
            key: 'lastLogin',
            value: Date.now()
        });
    }
}
